var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.4993V8.99999C16.5 7.80652 16.0259 6.66193 15.182 5.81802C14.3381 4.97411 13.1935 4.5 12 4.5C10.8065 4.5 9.66193 4.97411 8.81802 5.81802C7.97411 6.66193 7.5 7.80652 7.5 8.99999V16.5C7.5 17.2956 7.81607 18.0587 8.37868 18.6213C8.94129 19.1839 9.70435 19.5 10.5 19.5C11.2956 19.5 12.0587 19.1839 12.6213 18.6213C13.1839 18.0587 13.5 17.2956 13.5 16.5V8.99999C13.5 8.60217 13.342 8.22064 13.0607 7.93933C12.7793 7.65803 12.3978 7.49999 12 7.49999C11.6022 7.49999 11.2206 7.65803 10.9393 7.93933C10.658 8.22064 10.5 8.60217 10.5 8.99999V15.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/Attachment.f3d8408542565b415bbc329f3d118a7b.svg";
export { ForwardRef as ReactComponent };